import api from "./api";

export const getProcessAtual = async(filters: any) => {
    const response = await api.get(`process/listOneFilter?${filters.idUnitConsumer ? `idUnitConsumer=${filters.idUnitConsumer}` : ""}&status=${filters.status ? filters.status : ""}&cod_ref=${filters.cod_ref ? filters.cod_ref : ""}&idPlant=${filters.idPlant ? filters.idPlant : ""}&idCredential=${filters.idCredential ? filters.idCredential : ""}`);
    return response.data;
};